// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headerWrap":"f4iwc5Lgw_EN3vdplOdL","bodyWrap":"CYrY7LNu4ABEDmTKhnsa","searchTerm":"cEVDHhJTV1qMr9Pfxzyy","headerContent":"s3A1FfUbFgmFx5Yh3kPw"};